module.exports = __webpack_public_path__ + "static/img/展会介绍.0e5a8c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/展会介绍.jpg
// module id = pYnh
// module chunks = 1